// src/pages/restaurant-tables/LoungeTables.jsx
import React from 'react';
import LocationTables from './LocationTables';

const LoungeTables = () => {
  return <LocationTables locationKey="lounge" />;
};

export default LoungeTables;